module.exports = __webpack_public_path__ + "static/media/gift.732e8e61.svg";